class DynamicError extends Error {
}
class NotSupportedError extends DynamicError {
}
class EmailVerificationError extends DynamicError {
    constructor(code) {
        super();
        this.name = 'EmailVerificationError';
        this.code = code;
    }
}
class NoAccessError extends DynamicError {
    constructor({ walletPublicKey, email, }) {
        super('User does not have access');
        this.name = 'NoAccessError';
        this.email = email;
        this.walletPublicKey = walletPublicKey;
    }
}
class ChainalysisError extends DynamicError {
    constructor(walletPublicKey) {
        super('This address is not approved for access');
        this.name = 'ChainalysisError';
        this.walletPublicKey = walletPublicKey;
    }
}
class EmailAlreadyExistsError extends DynamicError {
    constructor() {
        super('Email already exists');
        this.name = 'EmailAlreadyExistsError';
    }
}
class UsernameAlreadyExistsError extends DynamicError {
    constructor() {
        super('Username already exists');
        this.name = 'UsernameAlreadyExistsError';
    }
}
class WalletNotDeployedError extends DynamicError {
    constructor() {
        super('Wallet has not been deployed');
        this.name = 'WalletNotDeployedError';
        this.code = 'wallet_not_deployed';
    }
}
class WalletUsedError extends DynamicError {
    constructor(code) {
        super();
        this.name = 'WalletUsedError';
        this.code = code;
    }
}

export { ChainalysisError, DynamicError, EmailAlreadyExistsError, EmailVerificationError, NoAccessError, NotSupportedError, UsernameAlreadyExistsError, WalletNotDeployedError, WalletUsedError };
